import React from "react";
import styles from "./profile-section.module.css";
import { Trans } from "@coworker/locales";
import { FixaText } from "../../../../shared/wrappers/FixaText/FixaText";
interface ProfileSectionHeaderProps {
  titleTranslationKey: string;
}

export const ProfileSectionHeader: React.FC<ProfileSectionHeaderProps> = ({
  titleTranslationKey,
}) => {
  return (
    <div>
      <div className={styles["section-header"]}>
        <FixaText
          className={styles["section-header-text"] as string}
          tagName="h3"
          textStyle="Heading.S"
        >
          <Trans>{titleTranslationKey}</Trans>
        </FixaText>
      </div>
    </div>
  );
};
